import * as Event from '../../events';
import ProductModel from '../../model/product-model';
import {isEmpty} from 'lodash';
import UIkit from '../../../uikit';
import * as GHPages from '../../config/ghpages';
import {setEditorById} from '../../config/ckeditor';

/**
 * Administrator - Product
 * 
 * @author wadahkode <mvp.dedefilaras@gmail.com>
 * @since version v1.0.85
 */
class Product extends ProductModel {
    constructor(table) {
        super(table);
        this.photoTmp = "";
    }
    
    create() {
        let form = document.getElementById('form-create-product'),
            buttonSave = document.querySelector('.quick-btn-create-product'),
            buttonDraft = document.querySelector('.quick-btn-draft-product');
        
        form.productCategory.innerHTML = `
            <option value="" selected>PILIH KATEGORI</option>
        `;
        this.getProductCategory(category => {
            form.productCategory.innerHTML += `
                <option value="${category.name}">${category.name}</option>
            `;
        });
        
        form.productName.addEventListener("keyup",function(){
            let val = this.value;
            form.productUrl.value = val.split(' ').join('-').toLowerCase();
        });
        
        const editor = setEditorById(document.querySelector('#editor'));
        
        form.querySelector('.js-upload').addEventListener('change', () => {
            this.previewPhoto(form.querySelector('.productPhoto'));
        });
        
        buttonSave.addEventListener('click', () => {
            buttonSave.setAttribute("disabled", true);
            buttonSave.innerHTML = `
                <span class="spinner"></span>
                <span>&nbsp;Please wait...</span>
            `;
            form.onsubmit = this.handleCreateProduct(form, buttonSave, editor);
        });
        
    }

    handleCreateProduct(form, btn, editor) {
        const {
            productName,
            productHostname,
            productUrl,
            productStock,
            productCategory,
            productPrice,
            productDiscount,
            productLocation,
            productCourier,
            productDetail
        } = form;
        
        var validate = this.validation(form, editor);
        
        validate.then(status => {
            if (status) {
                this.saveProduct({
                    "productName": productName.value,
                    "productUrl": productHostname.value + productUrl.value,
                    "productStock": parseInt(productStock.value),
                    "productCategory": productCategory.value,
                    "productPrice": parseInt(productPrice.value),
                    "productDiscount": isEmpty(productDiscount.value) ? false : parseInt(productDiscount.value),
                    "productLocation": productLocation.value,
                    "productCourier": productCourier.value,
                    "productDetail": isEmpty(productDetail.value) ? false : productDetail.value,
                    "productPhoto": isEmpty(this.photoTmp) ? GHPages.getOrigin().origin + GHPages.getOrigin().pathname + '/assets/avatar/no-image.png' : this.photoTmp,
                    "productKey": this.productKey
                });
            }
        });
        
        const previewPhoto = document.getElementById('preview-photo');
        
        setTimeout(function() {
            btn.disabled = false;
            btn.innerHTML = "Pajang sekarang";
            form.reset();
            //previewPhoto.src = "";
        }, 3000);
    }
    
    index() {
        var product = document.getElementById('view-product'),
            viewProduct = "";
        
        product.innerHTML = `
            <thead>
                <th>Nama produk</th>
                <th>Link</th>
                <th>Stok produk</th>
                <th>Kategori produk</th>
                <th>Harga produk</th>
                <th>Diskon produk</th>
                <th>Lokasi produk</th>
                <th>Kurir produk</th>
                <th>Deskripsi produk</th>
                <th>Foto produk</th>
                <th>Aksi</th>
            </thead>
        `;
        
        this.getProduct((productItem,key) => {
            product.innerHTML += this.viewProduct(productItem, key);
        });
    }
    
    previewPhoto(input) {
        if (input.files && input.files[0]) {
            var reader = new FileReader(),
            photo = document.getElementById('preview-photo');
            
            reader.onload = (e) => {
                this.photoTmp = e.target.result;
                photo.src = e.target.result;
                //photo.width = 144;
                //photo.height = 144;
                photo.className = "uk-height-medium";
                //photo.setAttribute("uk-img","");
            };
            reader.readAsDataURL(input.files[0]); // convert to base64 string
        }
    }
    
    validation(...input) {
        const {
            productName,
            productUrl,
            productStock,
            productCategory,
            productPrice,
            productDiscount,
            productLocation,
            productCourier,
            productDetail
        } = input[0];
        
        let editor = input[1];
        
        return editor.then(snapshot => {
            productDetail.value = snapshot.getData();
            if (isEmpty(productName.value)) {
                UIkit.notification("Nama produk tidak boleh kosong!", {
                    status: 'warning',
                    timeout: 2000
                });
            }
            else if (isEmpty(productStock.value)) {
                UIkit.notification("Stok produk tidak boleh kosong!", {
                    status: 'warning',
                    timeout: 2000
                });
            }
            else if (isEmpty(productCategory.value)) {
                UIkit.notification("Pilih salah satu kategori!", {
                    status: 'warning',
                    timeout: 2000
                });
            }
            else if (isEmpty(productPrice.value)) {
                UIkit.notification("Harga produk tidak boleh kosong!", {
                    status: 'warning',
                    timeout: 2000
                });
            }
            else if (isEmpty(productLocation.value)) {
                UIkit.notification("Pilih lokasinya!", {
                    status: 'warning',
                    timeout: 2000
                });
            }
            else if (isEmpty(productCourier.value)) {
                UIkit.notification("Pilih kurirnya!", {
                    status: 'warning',
                    timeout: 2000
                });
            } else {
                return true;
            }
        });
    }
    
    viewProduct(item, key) {
        return `
            <tbody>
                <td>${item.productName}</td>
                <td><a href="${item.productUrl}">${item.productUrl}</a></td>
                <td>${item.productStock}</td>
                <td>${item.productCategory}</td>
                <td>${item.productPrice}</td>
                <td>${(item.productDiscount == false) ? 'tidak ada' : item.productDiscount}</td>
                <td>${item.productLocation}</td>
                <td>${item.productCourier}</td>
                <td>${item.productDetail}</td>
                <td><img src="${item.productPhoto}" width="32" height="32"/></td>
                <td>
                    <a href="${item.productKey}" class="uk-button uk-button-small uk-button-primary">edit</a>
                    <a href="${item.productKey}" class="uk-button uk-button-small uk-button-danger">hapus</a>
                </td>
            </tbody>
        `;
    }
}

export default Product;
